import { Button } from "@radix-ui/themes";
import toast from "react-hot-toast";
import { useCopyToClipboard } from "react-use";
import { useAppSelector } from "@/app/appStore";

export function CurrentTime() {
  const currentTime = useAppSelector((state) => state.player.currentTime);
  const copyToClipboard = useCopyToClipboard();

  const DEFAULT_TIME = "00:00:00";

  return (
    <Button
      variant="ghost"
      size={{
        initial: "1",
        md: "2",
      }}
      color="gray"
      className="tabular-nums"
      onClick={() => {
        copyToClipboard[1](
          currentTime ? new Date(currentTime).toISOString() : DEFAULT_TIME
        );
        toast.success("Copied to clipboard");
      }}
    >
      {currentTime ? new Date(currentTime).toISOString() : DEFAULT_TIME}
    </Button>
  );
}
